import React from "react";
import { RichText } from "prismic-dom";
import Link from "gatsby-link";
import styled, { css } from "styled-components";
import { Box } from "rebass";
import GradientCard from "./GradientCard";
import Article from "./Article";
import PrimaryButton from "./Buttons/PrimaryButton";

let linkResolver = function(doc) {
  return "/" + doc.type;
};

const Card = styled(GradientCard)`
  @media (max-width: 40em) {
    margin-right: -24px;
    margin-left: -24px;
  }

  * {
    &::selection {
      color: ${props => props.theme.colors.grey[2]};
      background-color: ${props => props.theme.colors.violet};
    }
  }
`;

const CalloutCard = props => (
  <Box mb={5}>
    <Card
      callout={props.callout}
      image={
        props.callout.callout_image.url
          ? props.callout.callout_image.half.url
          : ""
      }
    >
      {props.callout.callout && (
        <Article
          dangerouslySetInnerHTML={{
            __html: RichText.asHtml(props.callout.callout, linkResolver)
          }}
        />
      )}
      {props.callout.button_text && (
        <Box mt={5}>
          <PrimaryButton
            children={props.callout.button_text}
            is={
              props.callout.button_file.url
                ? "a"
                : props.callout.button_link
                  ? props.callout.button_link.indexOf("http") !== -1 ||
                    props.callout.button_link.indexOf("mailto") !== -1
                    ? "a"
                    : Link
                  : Link
            }
            to={"/" + props.lang + "/" + props.callout.button_link}
            href={
              props.callout.button_link
                ? props.callout.button_link
                : props.callout.button_file ? props.callout.button_file.url : ""
            }
            target="_blank"
          />
        </Box>
      )}
    </Card>
  </Box>
);

export default CalloutCard;



// WEBPACK FOOTER //
// ./src/components/CalloutCard.js